export const defaultMirrorFlyIcons = {
    mf_CallLogs:"",
    mf_IconSmile:"",
    mf_CallLogCount: "",
    mf_NewChat:"",
    mf_NewGroup:"",
    mf_DotMenu: "",
    mf_IconArchive:"",
    mf_Settings:"",
    mf_ChatMute: "",
    mf_ChatMuteOff: "",
    mf_IconMeetingVideo: "",
    mf_IconMissedCallAudio: "",
    mf_IconMissedCallVideo: "",
    mf_LoginInfo: "",
    mf_RejectCall: "",
    mf_AudioOn: "",
    mf_AudioOff: "",
    mf_VideoOn: "",
    mf_VideoOff: "",
    mf_AttenCall: "",
    mf_BackToChat: "",
    mf_Avatar: "",
    mf_Chat:"",
    mf_Call:"",
    mf_UnsavedContact: "",
    mf_Video:"",
    mf_ArrowBack:"",
    mf_MailIcon: "",
    mf_MailiconSolid: "",
    mf_EmptyContact: "",
    mf_Search: "",
    mf_Close: "",
    mf_Logout: "",
    mf_Tick: "",
    mf_RecordAudio:"",
    mf_StartRecord: "",
    mf_StopRecord: "",
    mf_IconLoader: "",
    mf_ClosePopup: "",
    mf_FloatingCallVideo: "",
    mf_FloatingCallAudio: "",
    mf_FloatingCallAction: "",
    mf_FloatingCallActionSm: "",
    mf_CallLogs2: "",
    mf_CloseWhite: "",
    mf_Retake: "",
    mf_CameraIcon: "",
    mf_Menu: "",
    mf_DropdownArrow: "",
    mf_DropdownArrow2: "",
    mf_Close2: "",
    mf_Info: "",
    mf_AddParticiapants: "",
    mf_Blocked: "",
    mf_Delete: "",
    mf_Done: "",
    mf_Edit: "",
    mf_GoBack: "",
    mf_Status: "",
    mf_UnBlock: "",
    mf_Next: "",
    mf_BlockedIcon: "",
    mf_ZoomIn: "",
    mf_ZoomOut: "",
    mf_Attachment:"",
    mf_SendMessage: "",
    mf_ChatAudioReceiver: "",
    mf_ChatAudioSender: "",
    mf_ChatAudioReceiver2: "",
    mf_ChatAudioRecorder: "",
    mf_ChatAudioSender2: "",
    mf_ChatAudioRecorderDark: "",
    mf_Audio2: "",
    mf_ChatContact: "",
    mf_ChatContactRecei: "",
    mf_ContactDetails: "",
    mf_DocumentReceiver: "",
    mf_DocumentSender: "",
    mf_DocumentDownload: "",
    mf_SingleForward: "",
    mf_SingleForward2: "",
    mf_Playbtn: "",
    mf_Playbtn2: "",
    mf_VideoIcon: "",
    mf_VideoIcon3: "",
    mf_AttachmentCamera:"",
    mf_AttachmentDoc:"",
    mf_AttachmentImageVideo:"",
    mf_AttachMusic:"",
    mf_DeleteMessage: "",
    mf_Forward: "",
    mf_MessageInfo: "",
    mf_Reply: "",
    mf_Star: "",
    mf_Starred: "",
    mf_UnStar: "",
    mf_StarredDark: "",
    mf_UnStarDark: "",
    mf_Translate: "",
    mf_PreviewClose: "",
    mf_PreviewDownload: "",
    mf_PreviewForward: "",
    mf_PreviewStar: "",
    mf_PreviewStarActive: "",
    mf_DropDownload: "",
    mf_PreviewChat: "",
    mf_SelectedForward: "",
    mf_SelectedClose: "",
    mf_ReplyAudio: "",
    mf_ReplyAudioRecorded: "",
    mf_ReplyDocument: "",
    mf_ReplyContact: "",
    mf_ReplyPlay: "",
    mf_ChatAudioSenderIcon: "",
    mf_ChatAudioReceiverIcon: "",
    mf_ChatBubble: "",
    mf_FiletypePlaceholderSender: "",
    mf_FiletypePlaceholderReceiver: "",
    mf_Audio: "",
    mf_Camera: "",
    mf_CloseReply: "",
    mf_Contact: "",
    mf_DocumentIcon: "",
    mf_Location: "",
    mf_ReplyVcard: "",
    mf_VideoIcon2: "",
    mf_Reset: "",
    mf_AudioCall: "",
    mf_VideoCall: "",
    mf_CloseMessageInfoDetails: "",
    mf_EmptyDeliver: "",
    mf_IconEmptyArchive: "",
    mf_OpenMessageInfoDetails: "",
    mf_CloseMessageInfo: "",
    mf_CreateGroup: "",
    mf_EditCamera: "",
    mf_Remove: "",
    mf_Takephoto: "",
    mf_Upload: "",
    mf_Upload2: "",
    mf_Upload3: "",
    mf_Viewphoto: "",
    mf_BlockedInfo: "",
    mf_Rechatchatimage: "",
    mf_Nochat: "",
    mf_AudioOnGoingCall: "",
    mf_OnGoingCall: "",
    mf_RecentCallHangup: "",
    mf_RecentCallMute: "",
    mf_RecentCallMuteActive: "",
    mf_RecentVideoCall: "",
    mf_RecentAudioCall: "",
    mf_RecentDeletedMessage: "",
    mf_TileView: "",
    mf_EmptyCallLog: "",
    mf_TileViewRemove: "",
    mf_IconIncoming: "",
    mf_IconOutgoing: "",
    mf_IconIncomingMissed: "",
    mf_IconAudiocall: "",
    mf_IconVideocall: "",
    mf_IconPin: "",
    mf_IconPinActive: "",
    mf_StarBlue: "",
    mf_StarGray: "",
    mf_InfoIcon: "",
    mf_EmptySearch: "",
    mf_EventWaiting: "",
    mf_MediaDownload: "",
    mf_MediaDownloadLite: "",
    mf_NoMedia: "",
    mf_AudioPermissionIcon: "",
    mf_ClearChat: "",
    mf_FileLoaderCircle: "",
    mf_Fileloader: "",
    mf_IconUploading: "",
    mf_IconSendingFailed: "",
    mf_IconBackArrow: "",
    mf_IconScroltToDown: "",
    mf_IconExitGroup: "",
    mf_IconInvite: "",
    mf_IconParticiants: "",
    mf_IconStaredArrow: "",
    mf_IconStaredMenu: "",
    mf_IconNoStaredMessage: "",
    mf_IconNoStar: "",
    mf_IconCopy: "",
    mf_IconLink: "",
    mf_IconAudioIncommingCall: "",
    mf_IconAudioMissedCall: "",
    mf_IconAudioOutgoingCall: "",
    mf_IconVideoOutgoingCall: "",
    mf_IconVideoIncommingCall: "",
    mf_IconVideoMissedCall: "",
    mf_IconInvalidLink: "",
    mf_IconEditProfile: "",
    mf_IconUserPlaceholder: "",
    mf_BackToChatWhite: "",
    mf_CallEndicon: "",
    mf_Callendiconplain: "",
    mf_IconVerifiyedAccount: "",
    mf_IconReport: "",
    mf_IconGroupReport: "",
    mf_IconSingleReport: ""
};